import React from 'react'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'

interface HasConversionPermissionProps {
  children: React.ReactNode
}

export const useHasConceptPermission = () => {
  const selectedRegion = useSelector((state: IRootReducerState) => state.region.selectedRegion)
  const isNLRegion = selectedRegion.startsWith('uk') || selectedRegion.includes('.uk.')

  const hasPermission = isNLRegion || selectedRegion === 'localhost'
  return hasPermission
}

const HasConceptConfigurationPermission = ({ children }: HasConversionPermissionProps) => {
  const selectedRegion = useSelector((state: IRootReducerState) => state.region.selectedRegion)
  const isNLRegion = selectedRegion.startsWith('uk') || selectedRegion.includes('.uk.')

  // only UK environment has permission to access config configuration
  // other environments return an api error
  const hasPermission = isNLRegion || selectedRegion === 'localhost'

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{hasPermission ? children : null}</>
}

export default HasConceptConfigurationPermission
